import React,{useEffect} from 'react'
import { Link } from 'react-router-dom'
import Header from'../Component/Header'
import Footer from'../Component/Footer'
const EntranceExamClassXI = () => {
     useEffect(() => {
        document.title = 'EntranceExamClassXI -  St Peters convent School Faridabad Haryana';  
    }, []); 
  return (
    <>
      <Header />
      <div className="innerslide">
        <ul className="breadcrumb">
          <li>
            <Link to="/"> Home</Link>{" "}
            
          </li>
          <li>   Academics  </li>
          <li>Entrance Exam Class XI </li>
        </ul>
      </div>
      <div className="innersec">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <h1>Entrance Exam Class XI   </h1>
            </div>
          </div>
          
        </div>
      </div>
      <Footer />
    </>
  );
}

export default EntranceExamClassXI
